import React, { useState } from "react";
import { FaPlusCircle, FaTimes } from "react-icons/fa";
import CreateTreatmentPlan from "./CreateTreatmentPlan";
import { useNavigate } from "react-router-dom";
// Make sure to import CreateTreatmentPlan if it isn't already imported
// import CreateTreatmentPlan from "./CreateTreatmentPlan";

export default function VisitModal({
  patient,
  closeVisit,
  addTreatment,
  trackTreatment,
  procedureMasterData, // if this data is coming in as a prop
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleAddTreatment = () => {
    setIsModalOpen(true);
  };

  // Close modal handler
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // This function handles saving the new treatment plan
  const handleCreateTreatment = (treatmentData) => {
    if (typeof addTreatment === "function") {
      addTreatment(treatmentData);
    }
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl p-8 relative">
          {/* Enhanced Close Button */}
          <button
            className="absolute top-4 right-4 text-gray-600"
            onClick={closeVisit}
          >
            <FaTimes className="w-6 h-6" />
          </button>

          {/* Header with Title and Add Button */}
          <div className="flex justify-between items-center mb-6 mt-6">
            <h3 className="text-3xl font-semibold text-gray-800">
              Treatment Plans for{" "}
              <span className="text-green-600">{patient.name}</span>
            </h3>

            <button
              className="flex items-center space-x-2 px-4 py-2 bg-green-500 text-white rounded-full hover:bg-green-600 transition"
              onClick={handleAddTreatment}
            >
              <FaPlusCircle className="text-2xl" />
              <span>Add Treatment</span>
            </button>

            {/* <button
              onClick={handleAddTreatment}
              className="px-6 py-2 bg-green-500 text-white font-medium rounded-md hover:bg-green-600 transition shadow-md"
            >
              Add New Treatment
            </button> */}
          </div>

          {/* Treatment Cards */}
          {patient.treatments && patient.treatments.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {patient.treatments.map((treatment) => (
                <div
                  key={treatment.id}
                  className="bg-gray-50 border border-gray-200 rounded-xl p-6"
                >
                  <h4 className="text-lg font-semibold text-gray-700 mb-2">
                    {treatment.name}
                  </h4>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Doctor:</span>{" "}
                    {treatment.doctor || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Start Date:</span>{" "}
                    {treatment.startDate || "N/A"}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">End Date:</span>{" "}
                    {treatment.endDate || "N/A"}
                  </p>
                  <div className="mt-4 flex justify-end">
                    <button
                      onClick={() =>
                        navigate(`/new/treatment-tracker/${treatment.id}`)
                      }
                      className="px-4 py-2 bg-green-500 text-white font-medium rounded-md hover:bg-green-600 transition shadow-md"
                    >
                      Track
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-600">
              No treatments added yet. You can create one by clicking on the{" "}
              <span className="font-semibold text-green-600">
                Add New Treatment
              </span>{" "}
              button.
            </p>
          )}
        </div>
      </div>
      {/* Modal for Creating Treatment Plan */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-4xl p-6 rounded-lg shadow-lg relative">
            <div className="flex justify-between items-center mb-6 border-b pb-4">
              <h2 className="text-2xl font-bold text-gray-800">
                Add New Treatment Plan
              </h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-800 text-3xl focus:outline-none"
              >
                &times;
              </button>
            </div>
            <div className="overflow-y-auto max-h-[80vh]">
              <CreateTreatmentPlan
                onSavePlan={handleCreateTreatment}
                patient={patient}
                proceduresMaster={procedureMasterData}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
